import React from 'react';
import styled from 'styled-components';
import theme from '../styles/theme';

interface FooterContainerProps {
  $isCollapsed: boolean;
}

const FooterContainer = styled.footer<FooterContainerProps>`
  position: fixed;
  bottom: 0;
  right: 0;
  width: calc(100% - ${props => (props.$isCollapsed ? '72px' : '260px')});
  background: ${theme.glass.light};
  backdrop-filter: ${theme.glass.blur};
  -webkit-backdrop-filter: ${theme.glass.blur};
  padding: 14px 24px;
  text-align: left;
  border-top: 1px solid ${theme.colors.cardBorder};
  transition: width ${theme.transitions.base};
  z-index: 10;

  @media (max-width: 768px) {
    width: 100%;
    padding: 12px 16px;
  }
`;

const FooterText = styled.p`
  color: ${theme.colors.textMuted};
  margin: 0;
  font-size: ${theme.typography.small};
  font-weight: 500;

  span {
    color: ${theme.colors.textSecondary};
    font-weight: 600;
  }
`;

interface FooterProps {
  isCollapsed: boolean;
}

const Footer: React.FC<FooterProps> = ({ isCollapsed }) => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer $isCollapsed={isCollapsed}>
      <FooterText>
        Copyright © <span>{currentYear}</span> All rights reserved.
      </FooterText>
    </FooterContainer>
  );
};

export default Footer;
